import React from 'react';
import '../../styles/card.css';

const NumberCard = ({ title, value, isPositive }) => {
  return (
    <div className="card-container">
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-value">{value}</p>
        <div className={`card-change ${isPositive ? 'card-positive' : 'card-negative'}`}>
          {/* <span>{percentage}%</span> */}
          {/* <span>{change}</span> */}
        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <div className="App">
      <NumberCard
        title="Applied"
        value="27"
        // percentage="+3"
        // change="up"
        isPositive={true}
      />
      {/* <NumberCard
        title="Daily earnings"
        value="$95"
        percentage="-2"
        change="down"
        isPositive={false}
      /> */}
    </div>
  );
};

export default App;